export const ONE_COMPOSER_SMART_FIELD_KEYS = [
    'project.event_name',
    'project.event_date',
    'project.event_end_date',
    'project.event_time_start',
    'project.event_time_end',
    'project.event_location',
    'project.project_type',
    'project.event_budget',
    'project.event_guests',
    'client.full_name',
    'client.first_name',
    'client.last_name',
    'client.email',
    'client.phone_number',
    'client.address',
    'client.initials',
    'client.organization_name',
    'second_client.full_name',
    'second_client.first_name',
    'second_client.last_name',
    'second_client.email',
    'second_client.phone_number',
    'second_client.address',
    'second_client.initials',
    'second_client.organization_name',
    'company.company_name',
    'company.website_url',
    'company.email',
    'company.phone_number',
    'company.address',
    'time.today',
    'user.full_name',
    'user.first_name',
    'user.last_name',
    'user.email',
    'user.phone_number',
    'user.address',
    'user.initials'
] as const;

const PAYMENT_SMART_FIELD_KEYS = [
    'payment.total_price',
    'payment.sub_total',
    'payment.invoice_number',
    'payment.first_payment_amount',
    'payment.first_payment_due_date',
    'payment.second_payment_amount',
    'payment.second_payment_due_date',
    'payment.third_payment_amount',
    'payment.third_payment_due_date',
    'payment.last_payment_amount',
    'payment.last_payment_due_date'
] as const;

const SESSION_SMART_FIELD_KEYS = [
    'session.date_time_start',
    'session.date_start',
    'session.meeting_location',
    'session.session_name'
] as const;

export const CUSTOM_PROJECT_FIELD_KEY_PREFIX = 'custom_field';

export const CUSTOM_CLIENT_FIELD_KEY_PREFIX = 'client_custom_fields';
export const CUSTOM_SECOND_CLIENT_FIELD_KEY_PREFIX =
    'second_client_custom_fields';

export const customClientFieldKeys = [
    CUSTOM_CLIENT_FIELD_KEY_PREFIX,
    CUSTOM_SECOND_CLIENT_FIELD_KEY_PREFIX
];

export const SMART_FIELD_KEYS = [
    ...PAYMENT_SMART_FIELD_KEYS,
    ...SESSION_SMART_FIELD_KEYS,
    ...ONE_COMPOSER_SMART_FIELD_KEYS
] as const;

export type TOneComposerSmartFieldKeys =
    (typeof ONE_COMPOSER_SMART_FIELD_KEYS)[number];

export type TSmartFieldKeys =
    | (typeof SMART_FIELD_KEYS)[number]
    | `custom_field.${string}`
    | `client_custom_fields.${string}`
    | `second_client_custom_fields.${string}`;

export type TGetFlowSmartFieldsRequestParams = {
    isTemplateEditor?: boolean;
    workspaceId?: string;
    flowId: string;
};

export type TGetOneComposerSmartFieldsRequestParams = {
    client_id?: string;
    is_template?: boolean;
    workspace_id?: string;
};

export type TServerSmartFieldSource =
    | 'payment'
    | 'session'
    | 'project'
    | 'client'
    | typeof CUSTOM_CLIENT_FIELD_KEY_PREFIX
    | 'second_client'
    | typeof CUSTOM_SECOND_CLIENT_FIELD_KEY_PREFIX
    | 'user'
    | 'company'
    | 'time'
    | typeof CUSTOM_PROJECT_FIELD_KEY_PREFIX;

export type IServerSmartField = {
    is_available: boolean;
    key: TSmartFieldKeys;
    source: TServerSmartFieldSource;
    value: string;
    is_suggested?: boolean;
    linked_id?: string;
};
